/* The product page on the work computer (09-25, the section's "Work computer" setting). The photos open in a Picture
   Viewer window: the toolbar pages through the color's photos, maximize (or a double click on the title bar) shows
   the photo full screen, minimize folds the window down to a file icon (the icon and the taskbar button bring it
   back), and the X asks, like XP's "save changes?", whether to add the item before closing; Don't add goes back to
   where the visitor came from, Cancel, Esc or a click outside the box just closes it. The taskbar's Start menu is the
   store's navigation. The Excel size chart marks the row of the size picked above. The picker, the gallery switch,
   the phone bar's timing and the cart stay portal.js's; nothing here changes what Add to cart does. */
(function () {
  'use strict';
  var root = document.querySelector('[data-pdp-xp]');
  if (!root || !Element.prototype.closest || window.twdPdp) { return; }
  window.twdPdp = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var viewer = root.querySelector('[data-viewer]');
  var icon = root.querySelector('.viewer-icon');
  var dialog = root.querySelector('[data-viewer-dialog]');
  var form = document.getElementById('requisition');
  var mainSubmit = form ? form.querySelector('[data-submit]') : null;
  var bar = document.querySelector('[data-sticky-bar]');
  var task = bar ? bar.querySelector('[data-viewer-action="task"]') : null;
  var start = bar ? bar.querySelector('[data-xp-action="start"]') : null;
  var menu = bar ? bar.querySelector('[data-xp-start]') : null;

  function play(el, frames, duration, easing, done) {
    if (reduce || !el.animate) { if (done) { done(); } return; }
    var called = false;
    var finish = function () { if (!called) { called = true; if (done) { done(); } } };
    var anim = el.animate(frames, { duration: duration, easing: easing });
    anim.onfinish = finish;
    anim.oncancel = finish;
  }

  function focusQuietly(el) {
    if (!el) { return; }
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }

  function scrollToEl(el) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - 12;
    try { window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, top); }
  }

  // While the window folds, a stray second click must not land on whatever slides in under the pointer.
  var quietUntil = 0;
  function quiet(ms) { quietUntil = Date.now() + ms; }
  document.addEventListener('click', function (event) {
    if (Date.now() < quietUntil) { event.preventDefault(); event.stopPropagation(); }
  }, true);

  /* The toolbar: previous and next walk the thumbnails the picker left visible (the current color's photos). */
  function stepPhoto(dir) {
    var labels = Array.prototype.filter.call(root.querySelectorAll('.gallery__thumbs label'), function (l) { return !l.hidden; });
    if (labels.length < 2) { stepColor(dir); return; }
    var current = root.querySelector('.gallery__radio:checked');
    var at = 0;
    for (var i = 0; i < labels.length; i++) {
      if (current && labels[i].getAttribute('for') === current.id) { at = i; break; }
    }
    var next = document.getElementById(labels[(at + dir + labels.length) % labels.length].getAttribute('for'));
    if (next) {
      next.checked = true;
      next.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* One photo in this color (his 09-26 ask: the arrows felt dead): the arrows step the colorway instead, through the
     picker itself, as a tap on the next swatch would, so the variant, the gallery, "Shown in" and the size all follow
     the way they already do. One color and one photo: nothing to step to, as before. */
  function stepColor(dir) {
    var radios = root.querySelectorAll('.opt--color input[type="radio"]:not(:disabled)');
    if (radios.length < 2) { return; }
    var at = 0;
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].checked) { at = i; break; }
    }
    var next = radios[(at + dir + radios.length) % radios.length];
    next.checked = true;
    next.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Maximize: the viewer fixed over the page, a placeholder keeps the layout from jumping. */
  function setMaxLabels(on) {
    var buttons = root.querySelectorAll('[data-viewer-action="max"]');
    for (var i = 0; i < buttons.length; i++) {
      var label = buttons[i].getAttribute(on ? 'data-label-restore' : 'data-label-max');
      if (label) { buttons[i].setAttribute('aria-label', label); buttons[i].setAttribute('title', label); }
    }
  }

  function isMax() { return viewer && viewer.classList.contains('xp--max'); }

  function maximize() {
    if (!viewer || isMax() || viewer.hidden) { return; }
    var holder = document.createElement('div');
    holder.className = 'xp-placeholder';
    holder.style.height = viewer.offsetHeight + 'px';
    viewer.parentNode.insertBefore(holder, viewer);
    viewer.classList.add('xp--max');
    document.documentElement.classList.add('xp-locked');
    setMaxLabels(true);
    play(viewer, [{ transform: 'scale(0.97)', opacity: 0.6 }, { transform: 'none', opacity: 1 }], 160, 'ease-out');
  }

  function unmaximize() {
    if (!isMax()) { return; }
    viewer.classList.remove('xp--max');
    document.documentElement.classList.remove('xp-locked');
    var holder = viewer.parentNode.querySelector('.xp-placeholder');
    if (holder) { holder.parentNode.removeChild(holder); }
    setMaxLabels(false);
  }

  /* Minimize: the window folds away and its file icon takes its place; the icon or the taskbar button restores it. */
  function setTask(pressed) { if (task) { task.setAttribute('aria-pressed', pressed ? 'true' : 'false'); } }

  function minimize() {
    if (!viewer || viewer.hidden) { return; }
    unmaximize();
    quiet(600);
    var height = viewer.offsetHeight;
    viewer.style.overflow = 'hidden';
    viewer.style.transformOrigin = 'left bottom';
    play(viewer, [
      { height: height + 'px', opacity: 1, transform: 'none' },
      { height: '0px', opacity: 0, transform: 'scale(0.15)' }
    ], 300, 'cubic-bezier(0.4, 0, 0.9, 0.6)', function () {
      viewer.hidden = true;
      viewer.style.overflow = '';
      viewer.style.transformOrigin = '';
      if (icon) { icon.hidden = false; }
      setTask(false);
      focusQuietly(icon);
    });
  }

  function restore() {
    if (!viewer || !viewer.hidden) { return; }
    quiet(580);
    if (icon) { icon.hidden = true; }
    viewer.hidden = false;
    setTask(true);
    var height = viewer.offsetHeight;
    viewer.style.overflow = 'hidden';
    viewer.style.transformOrigin = 'left bottom';
    play(viewer, [
      { height: '0px', opacity: 0, transform: 'scale(0.15)' },
      { height: height + 'px', opacity: 1, transform: 'none' }
    ], 280, 'cubic-bezier(0.2, 0.6, 0.3, 1)', function () {
      viewer.style.overflow = '';
      viewer.style.transformOrigin = '';
      focusQuietly(viewer.querySelector('[data-viewer-action="min"]'));
    });
    var r = viewer.getBoundingClientRect();
    if (r.top < 0 || r.top > window.innerHeight - 80) { scrollToEl(viewer); }
  }

  /* Close: "Add The Cloud Tee (White / S) to your cart before closing?" Add to cart, Don't add, Cancel. */
  function itemLabel() {
    var values = [];
    var picked = root.querySelectorAll('[data-picker] .opt:not(.opt--single) input:checked');
    for (var i = 0; i < picked.length; i++) { values.push(picked[i].value); }
    var title = root.getAttribute('data-title') || '';
    return values.length ? title + ' (' + values.join(' / ') + ')' : title;
  }

  function askToClose() {
    unmaximize();
    startMenu(false);
    if (!dialog || typeof dialog.showModal !== 'function') { return; }
    var text = dialog.querySelector('[data-close-text]');
    if (text) { text.textContent = (text.getAttribute('data-template') || '').replace('[item]', itemLabel()); }
    var add = dialog.querySelector('[data-viewer-action="add"]');
    if (add) { add.disabled = !mainSubmit || mainSubmit.disabled; }
    if (!dialog.open) { dialog.showModal(); }
    focusQuietly(add && !add.disabled ? add : dialog.querySelector('[data-viewer-action="cancel"].xp-btn'));
  }

  function leave() {
    var ref = document.referrer;
    var sameSite = ref && ref.indexOf(window.location.origin + '/') === 0 && ref.split('#')[0] !== window.location.href.split('#')[0];
    if (sameSite && window.history.length > 1) { window.history.back(); return; }
    window.location.href = root.getAttribute('data-leave') || '/collections/all';
  }

  function addToCart() {
    if (dialog && dialog.open) { dialog.close(); }
    if (!form || !mainSubmit || mainSubmit.disabled) { return; }
    if (typeof form.requestSubmit === 'function') { form.requestSubmit(mainSubmit); } else { mainSubmit.click(); }
  }

  /* The taskbar's Start menu: opens up from the taskbar; a click outside, Esc or focus leaving it closes it. */
  function startMenu(open, focusFirst) {
    if (!menu || !start) { return; }
    if (!open && menu.hidden) { return; }
    menu.hidden = !open;
    start.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      play(menu, [{ opacity: 0, transform: 'translateY(6px)' }, { opacity: 1, transform: 'none' }], 120, 'ease-out');
      if (focusFirst) { focusQuietly(menu.querySelector('a, button')); }
    }
  }

  document.addEventListener('click', function (event) {
    if (dialog && event.target === dialog) { dialog.close(); return; }
    var startBtn = event.target.closest('[data-xp-action="start"]');
    if (startBtn && bar && bar.contains(startBtn)) { startMenu(menu && menu.hidden, event.detail === 0); return; }
    var control = event.target.closest('[data-viewer-action]');
    if (!control) { return; }
    var action = control.getAttribute('data-viewer-action');
    if (action !== 'close') { startMenu(false); }
    if (action === 'prev') { stepPhoto(-1); }
    else if (action === 'next') { stepPhoto(1); }
    else if (action === 'max') { if (isMax()) { unmaximize(); } else { maximize(); } }
    else if (action === 'min') { minimize(); }
    else if (action === 'restore') { restore(); }
    else if (action === 'task') { if (viewer && viewer.hidden) { restore(); } else { minimize(); } }
    else if (action === 'close') { askToClose(); }
    else if (action === 'cancel') { if (dialog) { dialog.close(); } }
    else if (action === 'leave') { if (dialog) { dialog.close(); } leave(); }
    else if (action === 'add') { addToCart(); }
  });

  // A press outside the open Start menu only closes it: the click that follows is swallowed, so it never also
  // follows what is under it. Handled on pointerdown because pressing a link focuses it before the click arrives.
  // The swallow lasts one press: a press that turns into a scroll (no click) must not eat the next tap.
  var swallowUntil = 0;
  function outside(target) { return menu && !menu.hidden && !target.closest('[data-xp-start]') && !target.closest('[data-xp-action="start"]'); }
  document.addEventListener('pointerdown', function (event) {
    if (!outside(event.target)) { return; }
    swallowUntil = Date.now() + 700;
    startMenu(false);
  }, true);
  document.addEventListener('pointercancel', function () { swallowUntil = 0; }, true);
  document.addEventListener('click', function (event) {
    var swallow = Date.now() < swallowUntil;
    if (!swallow && !outside(event.target)) { return; }
    swallowUntil = 0;
    event.preventDefault();
    event.stopPropagation();
    startMenu(false);
  }, true);
  document.addEventListener('focusin', function (event) {
    if (!menu || menu.hidden || event.target.closest('[data-xp-start]') || event.target.closest('[data-xp-action="start"]')) { return; }
    startMenu(false);
  });

  document.addEventListener('dblclick', function (event) {
    var titleBar = event.target.closest('[data-viewer] > .xp__bar');
    if (!titleBar || event.target.closest('button') || Date.now() < quietUntil) { return; }
    if (isMax()) { unmaximize(); } else { maximize(); }
  });

  document.addEventListener('keydown', function (event) {
    if (dialog && dialog.open) { return; }
    if (event.key === 'Escape' || event.key === 'Esc') {
      if (menu && !menu.hidden) { startMenu(false); focusQuietly(start); return; }
      unmaximize();
      return;
    }
    if (isMax() && (event.key === 'ArrowLeft' || event.key === 'ArrowRight')) {
      event.preventDefault();
      stepPhoto(event.key === 'ArrowLeft' ? -1 : 1);
    }
  });

  /* The size chart follows the size picked above (after portal.js has settled the options). */
  var sheet = root.querySelector('[data-size-sheet]');
  function markSize() {
    if (!sheet) { return; }
    var radio = root.querySelector('[data-opt-name="size"] input:checked');
    var value = radio ? radio.value : '';
    var rows = sheet.querySelectorAll('tr[data-size]');
    for (var i = 0; i < rows.length; i++) {
      rows[i].classList.toggle('is-current', rows[i].getAttribute('data-size') === value);
    }
  }
  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('[data-picker]')) { markSize(); }
  });
  markSize();

  // Theme editor: a section removed while maximized must not leave the page locked.
  document.addEventListener('shopify:section:unload', function () {
    document.documentElement.classList.remove('xp-locked');
  });
})();
